import * as React from "react";
import * as questionIds from "@teamprevent/common/questionnaires/questionnaireConfig/genericCase/questionIds";
import { ContextAwareProgressBarQuestionnaireSection } from "@teamprevent/common/questionnaires/components/ContextAwareProgressBarQuestionnaireSection";
import { QuestionConfig, getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { AnsweredQuestionWithId, FileAnswer } from "@teamprevent/common/questionnaires/model";
import { FileQuestion } from "@teamprevent/common/questionnaires/components/questions/FileQuestion";
import { Button, Divider } from "semantic-ui-react";

import { acceptableExtensions } from "@teamprevent/common/acceptableExtensions";

import { documentsSectionId } from "../GenericCaseForm";

interface Props {
    questionConfigs: QuestionConfig[];
    questions: AnsweredQuestionWithId[];
    readonly: boolean;
    removeQuestion(payload: { sectionId: string; id: string }): void;
    updateAnswer(payload: any): void;
}

export const SupportingDocumentSection: React.FunctionComponent<Props> = (
    { questionConfigs, questions, readonly, removeQuestion, updateAnswer }) => {
    const [documentCount, setDocumentCount] = React.useState<number>(0);

    const addDocument = React.useCallback(() => {
        updateAnswer({
            sectionId: documentsSectionId,
            id: `Document${documentCount + 1}`,
            question: { question: "", answer: { blobId: "", fileName: "" } }
        });
        setDocumentCount(prevValue => prevValue + 1);
    }, [documentCount, updateAnswer]);

    return (
        <ContextAwareProgressBarQuestionnaireSection id={documentsSectionId} title="Supporting Documents">
            <TextQuestion
                questionConfig={getQuestionConfig(questionConfigs, questionIds.SupportingDocumentsHeader)}
                readonly
                hideDivider
            />

            { questions
                .filter(question => question.answer && (question.answer as FileAnswer).blobId !== undefined)
                .map(fileQuestion =>
                    (
                        <FileQuestion
                            questionConfig={({ id: fileQuestion.id, questionText: "" })}
                            api={"/api/genericCase/document"}
                            readonly={readonly}
                            key={fileQuestion.id}
                            // eslint-disable-next-line react/jsx-no-bind
                            onRemove={() => removeQuestion({ sectionId: documentsSectionId, id: fileQuestion.id })}
                            acceptExtensions={acceptableExtensions}
                            hideDivider={true}
                        >
                        </FileQuestion>
                    )
                )}
            {!readonly &&
                <Button basic content="Add" onClick={addDocument} />
            }
            <Divider />
        </ContextAwareProgressBarQuestionnaireSection>
    );
};
